import React from 'react';
import { getPhoneVerdict, verdictConfidenceLabel } from '../utils/phoneVerdict';

function PhoneVerdictPanel({ enrichments, onRunLiveCarrier, liveLoading }) {
  const verdict = getPhoneVerdict(enrichments);
  const {
    verdict: verdictKey,
    headline,
    detail,
    confidence,
    assigned,
    live,
    liveStatus,
    liveReason,
    showLiveAction,
  } = verdict;

  const assignedLabel = assigned.carrier
    ? `${assigned.carrier}${assigned.line_type ? ` · ${assigned.line_type}` : ''}`
    : '—';
  const liveLabel = liveStatus === 'success'
    ? `${live.carrier || 'Unknown'} · ${live.line_type || 'Unknown'}`
    : liveStatus === 'skipped'
      ? 'Skipped'
      : liveStatus === 'error'
        ? 'Error'
        : 'Not run';

  return (
    <div className={`phone-verdict-panel verdict-${verdictKey}`}>
      <div className="phone-verdict-header">
        <div>
          <h2 className="phone-verdict-headline">{headline}</h2>
          <p className="phone-verdict-detail">{detail}</p>
        </div>
        <span className="phone-verdict-confidence">{verdictConfidenceLabel(confidence)}</span>
      </div>

      <div className="phone-verdict-grid">
        <div className="phone-verdict-stat">
          <div className="phone-verdict-stat-label">LERG assignment</div>
          <div className="phone-verdict-stat-value">{assignedLabel}</div>
        </div>
        <div className="phone-verdict-stat">
          <div className="phone-verdict-stat-label">Live carrier</div>
          <div className="phone-verdict-stat-value">{liveLabel}</div>
        </div>
        <div className="phone-verdict-stat">
          <div className="phone-verdict-stat-label">VoIP consensus</div>
          <div className="phone-verdict-stat-value">
            {verdict.consensus?.voip_consensus?.replace(/_/g, ' ') || 'none'}
          </div>
        </div>
        <div className="phone-verdict-stat">
          <div className="phone-verdict-stat-label">Assigned VoIP flag</div>
          <div className="phone-verdict-stat-value">
            {assigned.is_voip == null ? '—' : assigned.is_voip ? 'Yes' : 'No'}
          </div>
        </div>
      </div>

      {(showLiveAction || liveReason) && (
        <div className="phone-verdict-actions">
          {showLiveAction && (
            <button
              type="button"
              className="btn btn-primary btn-sm"
              disabled={liveLoading}
              onClick={onRunLiveCarrier}
            >
              {liveLoading ? 'Running live lookup…' : 'Run live carrier lookup'}
            </button>
          )}
          <p className="phone-verdict-note">
            {liveReason || (
              'Live lookup uses Twilio line-type intelligence (~$0.005/lookup). '
              + 'Add TWILIO_ACCOUNT_SID and TWILIO_AUTH_TOKEN to the server .env.django, then click Run.'
            )}
          </p>
        </div>
      )}
    </div>
  );
}

export default PhoneVerdictPanel;
